import React, {Component} from 'react';
import './Record.css';

import ReactTwig from 'react-twig';
import Render from "./Render";
import {Controlled as CodeMirror} from 'react-codemirror2'

require('codemirror/mode/xml/xml');
require('codemirror/mode/javascript/javascript');
require('codemirror/mode/twig/twig');

class Record extends Component {

    constructor() {
        super();

        this.state = {
            template: 'test',
            templateRender: 'test'
        };

        this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount() {
        console.log(this.props);
        this.setState({
            template: this.props.configurations.display,
            templateRender: this.props.configurations.display
        })
    }

    handleChange(event) {
        this.setState({template: event.target.value});
    }

    render() {
        const entry = this.props.entry;

        return (
            <div>

                <div className="no-print">
                    <h3>Editeur</h3>
                    <CodeMirror
                        value={this.state.template}
                        options={{
                            lineNumbers: true,
                            mode: {name: "twig", htmlMode: true}
                        }}
                        onBeforeChange={(editor, data, value) => {
                            this.setState({template: value});
                        }}
                        onChange={(editor, data, value) => {
                            this.setState({templateRender: value});

                        }}
                    />

                    <pre dangerouslySetInnerHTML={{__html: this.props.configurations}}/>
                </div>

                <h3 className="no-print">Rendu</h3>
                <div className="render">
                    <Render template={this.state.templateRender} entry={entry}/>
                </div>
            </div>
        )
    }


}


export default Record;


// WEBPACK FOOTER //
// ./src/Components/Reunion/Record.js